import CommonMessage from "../components/CommonMessage";
import React, { useEffect, useState, useMemo } from 'react';
import { getInsecure, isApiError } from "../service/api-actions";
import Cookies from "universal-cookie";
import { useSelector, useDispatch } from "react-redux";
import { formatMessageList } from '../helper/dataFormatHelper';
import web3Config from '../web3/web3Config.json';
import { getHostHelperContract } from "../helper/contract-helper.js";
import { getValidAccessToken } from "../auth/tokenGuard.js";
import { reportError, toErrorString } from "../utils/errorLogger.js";
import { toast, Bounce } from "react-toastify";
const cookies = new Cookies();

const Trash = () => {
  const dispatch = useDispatch();
  const [user] = useState(cookies.get("userObject"));
  const [allBoxList, setAllBoxList] = useState([]);
  const [loader, setLoader] = useState(true);
  const getRefreshMessage = useSelector((state) => state.refreshMessage);
  const [readList, setReadList] = useState([]);
  const [unreadList, setUnreadList] = useState([]);
  const refreshCount = useSelector((state) => state.refreshCount);
  const [count, setCount] = useState(0);
  const [text, setText] = useState("")
  useEffect(() => {
    getInsecureData();
  }, [getRefreshMessage]);

  useEffect(() => {
    getInsecureData();
  }, []);

  useEffect(() => {
    // NOT cookies.get() alone: the ML-DSA-87 token is ~10.5KB, over the browser's
    // ~4KB per-cookie limit, so the accessToken cookie is silently never stored.
    const token = getValidAccessToken();
    if (!token) return;
    const eventSource = new EventSource(
            `${web3Config.EMAIL_API}/events?token=${encodeURIComponent(token)}`
        );
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const receivedUser = `${data.split("@")[0]}@${web3Config.DOMAIN}`;
      const messageList = document.getElementById("list-message-component");
      const replyModal = document.getElementById("reply-modal");
      const composeEmail = document.getElementById("compose-email-send");
      const userName = user.name;
      if (receivedUser === userName && messageList && !replyModal && !composeEmail) {
        getInsecureData(true);
      }
    };

    eventSource.onerror = (error) => {
      console.error('EventSource failed:', error);
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };

  }, []);

  async function getInsecureData(autoFetch = false) {
    if (!autoFetch) {
      setLoader(true);
      setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
    }
    try {
      const insecureList = await getInsecure(user.name);
      // A FAILED fetch is not an empty mailbox. fetchAPI no longer answers failure with [], so this is
      // the point where the two are told apart — without it the catch below (and its toast) could never
      // run for a transport/401/429 failure and the user would simply be shown "no mail".
      if (isApiError(insecureList)) {
        throw new Error(insecureList.message || 'Failed to load emails');
      }
      const helperContract = getHostHelperContract();
      const attributes = await helperContract.methods.getAttributes(user.name).call();
      // The payload has no `res` at all on an empty mailbox: `insecureList.res?.map(...)` then handed
      // undefined to Promise.all and threw, which the catch below swallowed without ever clearing the
      // loader. Fall back to an empty list so a genuinely empty mailbox renders "no mail" instead of an
      // eternal spinner. (A failed fetch is handled above and never reaches here.)
      const insecureEmails = Array.isArray(insecureList?.res) ? insecureList.res : [];
      const formattedResult = await Promise.all(insecureEmails.map(async (email) => {
        const data = JSON.parse(email.parts[0].data);
        const encrypted_data = data.encrypted_data;
        const emailDetails = JSON.parse(data.email_details[2]);
        const sender = emailDetails.sender;
        const subject = emailDetails.subject;
        const folder = emailDetails.folder || '';
        const isRead = email.parts[0].status !== 0;
        const isFav = email.parts[0].fav === 1 ? true : false;
        const isArchive = email.parts[0].is_achieve;
        const deleteemails = email.parts[0].deleted_flag;
        const physmessage_id = email.physmessage_id;
        attributes.filter((att) => {
          return parseInt(att.id) === parseInt(email.physmessage_id);
        });


        return {
          mailtype: "web2emails",
          created_at: email.parts[0].internal_date,
          receivedDate: email.parts[0].internal_date,
          id: email.parts[0].message_id,
          encryptedData: encrypted_data,
          isStarred: isFav,
          sender: sender,
          senderName: sender,
          subject: subject,
          isRead: isRead,
          header: data.email_details[2],
          emailDetails: data.email_details[2],
          isCC: false,
          isBCC: false,
          isDeleted: false,
          isArchive,
          delete: deleteemails,
          physmessage_id,
          folder: folder,
          isfolder: (attributes.filter((att) => (att.attType === "folder") && parseInt(att.id) === parseInt(email.physmessage_id))[0])?.value ?? false,
        };
      }));
      const list = await formatMessageList(formattedResult, "Insecure");
      dispatch({ type: "ARICHVE_LIST", payload: list.allList });
      const filterReadList = list.readList.filter(data => data.delete !== 1 && data.delete !== 3 && data.isArchive !== true && data.isfolder !== true);
      const filterunreadlist = list.unReadList.filter(data => data.delete !== 1 && data.delete !== 3 && data.isArchive !== true && data.isfolder !== true);
      let responsemail = []
      for (let i = 0; i < list.allList.length; i++) {
        if (list.allList[i].isArchive === false) {
          responsemail.push(list.allList[i])
        }
      }

      const emailresponse = responsemail.filter((data) => {
        const isSentFolder = data.folder && data.folder.toLowerCase().includes('sent');
        const isTrashFolder = data.folder && data.folder.toLowerCase().includes('trash');
        if (data.delete !== 1 && data.delete !== 3 && data.isfolder !== true && !isSentFolder && !isTrashFolder) {
          return data
        }
        return null;
      })
      if (autoFetch && count < list.allList.length) {
        setAllBoxList(emailresponse);
        setReadList(filterReadList);
        setUnreadList(filterunreadlist);
      } else if (!autoFetch) {
        const readListAllEmails = emailresponse.filter(message => message.isRead);
        const unReadListAllEmails = emailresponse.filter(message => !message.isRead);
        setAllBoxList(emailresponse);
        setReadList(readListAllEmails);
        setUnreadList(unReadListAllEmails);
      }
      setCount(list.allList.length);
      dispatch({ type: "REFRESH_COUNT", payload: !refreshCount });
    } catch (err) {
      console.log(err);
      const errorStr = toErrorString(err || err.message);
      reportError({
        endpoint: '/getInsecureEmails',
        message: `FileName: Insecure.js, Fun: getInsecureData, ${String(err.message || 'Unhandled error')}`,
        error: errorStr,
        userName: localStorage.getItem('UserName') || '',
      });
      // Tell the user the fetch failed. Silently dropping back to an empty list would read as "you have no
      // mail", which is a different and worse lie than "we could not load it".
      if (!autoFetch) {
        toast.error("Could not load your email. Please check your connection and try again.", {
          toastId: "insecureLoadError",
          position: "top-center",
          transition: Bounce,
        });
      }
    } finally {
      // Moved out of the try: the loader used to be cleared only on the success path, so one failed
      // /getInsecureEmails call locked this screen on the spinner permanently.
      setLoader(false);
      setText("");
    }
  }
  const reRender = () => {
    dispatch({ type: "REFRESH_COUNT", payload: !refreshCount });
    getInsecureData();
  }

  const memoizedCommonMessage = useMemo(() => (
    <CommonMessage messageList={allBoxList} pageType={"Insecure"} unreadList={unreadList} readList={readList} loader={loader} reRender={reRender} text={text} />
  ), [allBoxList, unreadList, readList, loader]);

  return (
    <div className="inbox-container">
      {memoizedCommonMessage}
    </div>
  );
}

export default Trash